import { BaseEventTracking } from '/@/modules/core/app/models/abstracts/BaseEventTracking';
import { SegmentEvent } from '/@/integrations/segment/SegmentEvent';

export class NewRegistrationEventTracking extends BaseEventTracking {
  /**
   * @var {string}
   */
  static eventName = SegmentEvent.NEW_REGISTRATION;

  /**
   * @var {number}
   */
  userId;

  /**
   * @var {string}
   */
  userName;

  /**
   * @var {?string}
   */
  userRole;

  /**
   * @param user {User}
   */
  constructor(user) {
    super();
    this.userId = user.id;
    this.userName = user.name;
    this.userRole = user.estateAccount?.roleName ?? user.roleName;
  }
}
